// ./src/components/features/Upvotes/UpvoteCountBadge.tsx
//
// A compact "N guest upvotes" badge for the signup-item / POI / accommodation admin lists.
// Guests upvote items on the public event website (the unified event_guest_upvote table); the
// host/crew see the running tally here. Renders nothing when the count is 0 so unvoted rows
// stay clean.
import React from "react";
import { Badge, Tooltip } from "@mantine/core";

import { AppIcon } from "@em/ui";

export interface UpvoteCountBadgeProps {
  count?: number | null;
  size?: string;
}

export const UpvoteCountBadge: React.FC<UpvoteCountBadgeProps> = ({ count, size = "sm" }) => {
  const n = Number(count) || 0;
  if (n <= 0) {
    return null;
  }

  return (
    <Tooltip label={`${n} guest ${n === 1 ? "upvote" : "upvotes"}`} withArrow>
      <Badge
        size={size}
        variant="light"
        color="grape"
        radius="sm"
        leftSection={<AppIcon iconName="ThumbUp" size={12} />}
        style={{ flexShrink: 0 }}
      >
        {n}
      </Badge>
    </Tooltip>
  );
};
